<script lang="ts">import { afterNavigate } from "$app/navigation";
import { page } from "$app/stores";
import { cfgOptimoveEnabled, cfgOptimoveTenantId, cfgOptimoveTenantToken } from "@infinitro/config";
import { loggedIn, setOptimoveUserId, statePlayerId, trackOptimovePageVisit } from "@infinitro/global";
import { onMount } from "svelte";
const optimoveEnabled = cfgOptimoveEnabled();
let lastIdentifiedPlayerId = $state(undefined);
const syncUserIdentity = () => {
	if (!$loggedIn || !$statePlayerId) {
		lastIdentifiedPlayerId = undefined;
		return;
	}
	if (lastIdentifiedPlayerId === $statePlayerId) return;
	setOptimoveUserId($statePlayerId);
	lastIdentifiedPlayerId = $statePlayerId;
};
const logPageVisit = () => {
	trackOptimovePageVisit(window.location.href, document.title || "", $page.url.pathname);
};
onMount(() => {
	if (!optimoveEnabled) return;
	logPageVisit();
	syncUserIdentity();
});
afterNavigate(() => {
	if (!optimoveEnabled) return;
	logPageVisit();
	syncUserIdentity();
});
</script>

<svelte:head>
	{#if optimoveEnabled}
		<script
			async
			src="https://sdk.optimove.net/v2/websdk/?tenant_id={cfgOptimoveTenantId()}&tenant_token={cfgOptimoveTenantToken()}"
		></script>
	{/if}
</svelte:head>
